angular.module("app.modalControllers").controller("PreviewItemImageController", [
    '$scope',
    '$uibModalInstance',
    'imageSrc',
    function ($scope, $modalInstance, imageSrc) {
        $scope.imageSrc = imageSrc
    }
]);